/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React from 'react';
import { Route } from 'react-router';

import ErrorBoundaryRoutes from 'app/shared/error/error-boundary-routes';

import PaediatricParams from './paediatric-params';
import PaediatricParamsDetail from './paediatric-params-detail';
import PaediatricParamsUpdate from './paediatric-params-update';
import PaediatricParamsDeleteDialog from './paediatric-params-delete-dialog';

const PaediatricParamsRoutes = () => (
  <ErrorBoundaryRoutes>
    <Route index element={<PaediatricParams />} />
    <Route path="new" element={<PaediatricParamsUpdate />} />
    <Route path=":id">
      <Route index element={<PaediatricParamsDetail />} />
      <Route path="edit" element={<PaediatricParamsUpdate />} />
      <Route path="delete" element={<PaediatricParamsDeleteDialog />} />
    </Route>
  </ErrorBoundaryRoutes>
);

export default PaediatricParamsRoutes;
